import * as React from "react";
import EcAuthContext from "../../services/auth";
import styles from "./styles.module.css";
import { useMedia } from "use-media";

interface Props {
  header: React.ReactNode;
  main: React.ReactNode;
  loginScreen: React.ReactNode;
  sidebar?: React.ReactNode;
}

// export const EcLayout = ({ header, main, sidebar, loginScreen }: Props) => {
//   const { isUserAuthenticated } = React.useContext(EcAuthContext)

//   const isDesktop = useMedia({ minWidth: '900px' })

//   return (
//     <div className={styles[isDesktop ? 'desktop-grid' : 'mobile-grid']}>
//       <div className={styles.header}>{header}</div>

//       {/* check user authentication */}
//       {isUserAuthenticated ? (
//         // user is authenticated logged interface
//         <React.Fragment>
//           <aside
//             className={styles[isDesktop ? 'desktop-sidebar' : 'mobile-sidebar']}
//           >
//             {sidebar}
//           </aside>
//           <main className={styles[isDesktop ? 'desktop-main' : 'mobile-main']}>
//             {main}
//           </main>
//         </React.Fragment>
//       ) : (
//         // user is not authenticated - logged out
//         <React.Fragment>
//           <main className={styles.login}>{loginScreen}</main>
//         </React.Fragment>
//       )}
//     </div>
//   )
// }

export const EcLayout = ({ header, main, sidebar, loginScreen }: Props) => {
  const isDesktop = useMedia({ minWidth: "900px" });
  const { isUserAuthenticated } = React.useContext(EcAuthContext);

  return (
    <React.Fragment>
      <div className={styles.header}>{header}</div>
      {isUserAuthenticated ? (
        <div className={styles[isDesktop ? "desktop-grid" : "mobile-grid"]}>
          <aside
            className={styles[isDesktop ? "desktop-sidebar" : "mobile-sidebar"]}
          >
            {sidebar}
          </aside>
          <main className={styles[isDesktop ? "desktop-main" : "mobile-main"]}>
            {main}
          </main>
        </div>
      ) : (
        // user is not authenticated - logged out
        <React.Fragment>
          <main className={styles.login}>{loginScreen}</main>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
